import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { getBrandRiderDashboardByDays, getBrandStore, getBrandUsers } from "../../../services/StoreUsers/PostStoreUsers";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import RoleFilterModal from "./RoleFilterModal";
import UserCreateModal from "./UserCreateModal";
import AdminMenu from "../../AdminMenu";
import { getStoreRiderInfo } from "../../../services/StoreRiderInfo/StoreRiderInfo";
import SwitchRiderUserModal from "./SwitchRiderUserModal";

const SwitchRiderUserList = () => {
  const navigate = useNavigate();
  const [switchRiderUserModalVisible, setSwitchRiderUserModalVisible] = useState(false);
  const [storeUserData, setStoreUserData] = useState([]);
  const [storeData, setStoreData] = useState([]);
  const [selectedUserItemValue, setSelectedUserItemValue] = useState(null);
  const [assignStoreValue, setAssignStoreValue] = useState("");

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);
  const [storeId, setStoreId] = useState(null);
  const [riderInfo, setRiderInfo] = useState([]);

  const [riderJobsData, setRiderJobsData] = useState({});
  const [activeRider, setActiveRider] = useState(null);
  const [selectedRiderInfo, setSelectedRiderInfo] = useState({});
  const [selectedStoreValue, setSelectedStoreValue] = useState({});

  const handleAssignStoreChange = (selectedItem) => {
    setAssignStoreValue(selectedItem);
    fetchStoreRiderInfo(selectedItem);
    setStoreId(selectedItem);
  };

  const fetchStoreUser = () => {
    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const ResFilter = Res.filter((item) => item.enabledSwitchStoreUser === true);
          const newRes = ResFilter.map((item) => ({
            name: item.storeName,
            value: item.id,
          }));
          setStoreData(newRes);
          // fetchStoreRiderInfo(Res[0].id);
          // setStoreId(Res[0].id);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchStoreRiderInfo = (storeId) => {
    getStoreRiderInfo(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const newRes = Res.map((item) => ({
            name: item.fullName,
            value: item.id,
          }));
          setRiderInfo(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreUser();
  }, []);

  const receiveDataFromSwitchRiderUserModal = ({ success }) => {
    if (success) {
      fetchStoreUser();
    }
  };




  const FetchRiderInfo = (riderId) => {
    getBrandRiderDashboardByDays(storeId, riderId, 1000)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setRiderJobsData(Res)
          setActiveRider(riderId)
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }





  const handleSwitchRider = (item) => {
    setSelectedRiderInfo(item);
    setSelectedStoreValue(assignStoreValue);
    setSwitchRiderUserModalVisible(true);
  }



  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      const formattedCreatedDate =
        item.createdDate === null ? "" : formatDate(item.createdDate);
      const formattedNextRenewalDate =
        item.nextRenewalOn === null ? "" : formatDate(item.nextRenewalOn);
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    User Name :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.firstName + " " + item.lastName}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Register On :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {formattedCreatedDate}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      User Id :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.userLoginId}
                    </p>
                  </div>
                  <div
                    className="mr-4 mt-2"
                    style={{ background: "green", alignSelf: "center", paddingLeft: 5, paddingRight: 5, borderRadius: 4, cursor: "pointer" }}
                    onClick={() => {
                       
                      FetchRiderInfo(item.id);
                    }}
                  >
                     <p className="text-white">Get Info</p>
                  </div>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Next Renewal Date :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {formattedNextRenewalDate}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Register On :
                  </p>
                  {item.enabled === true ? (
                    <div className="flex">
                      <p className="text-lg font-medium capitalize mr-2">
                        Active{" "}
                      </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                        }
                      />
                    </div>
                  ) : (
                    <div className="flex">
                      <p className="text-lg font-medium capitalize mr-2">
                        DeActive{" "}
                      </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                        }
                      />
                    </div>
                  )}
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Assigned To :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item?.mappedWith}
                  </p>
                </div>
              </div>
              {activeRider === item?.id && <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Open Pickup :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {riderJobsData?.RIDER_PENDING_PICKUP?.jobCount}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Open Delivery :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {riderJobsData?.RIDER_PENDING_DELIVERY?.jobCount}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                   
                  {(riderJobsData?.RIDER_PENDING_PICKUP?.jobCount === 0 && riderJobsData?.RIDER_PENDING_DELIVERY?.jobCount === 0) &&<div
                    className="mr-4 mt-2"
                    style={{ background: "green", alignSelf: "center", paddingLeft: 5, paddingRight: 5, borderRadius: 4, cursor:"pointer" }}
                    onClick={() => handleSwitchRider(item)}
                  >
                    <p className="text-white">Switch Rider</p>
                  </div>}
                </div>
              </div>}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                User Management
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>


      <div className="flex flex-row">
        <div className="mt-4 mb-3 mx-4 flex-1">
          <FloatLabel>
            <Dropdown
              id="assignStoreValue"
              value={assignStoreValue}
              onChange={(e) => handleAssignStoreChange(e.target.value)}
              options={storeData}
              optionLabel="name"
              placeholder="Store"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />
            <label
              htmlFor="assignStoreValue"
              className="text-md"
              style={{ color: "blue" }}
            >
              Store <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) :

        storeId === null || "" ? 
            <div className="flex justify-content-center">
              <p className="text-xl font-medium">Please Select Store</p>
            </div>
            :

          riderInfo.length > 0 ? (
            <div>
              <div>
                <div
                  className="flex-1  surface-0"
                  style={{ "--surface-0": "#EAEFF5" }}
                >
                  <div className="flex justify-content-between mx-4">
                    <div className="py-1">
                      <p className=" text-2xl  font-bold ">ROLE RIDER</p>
                    </div>
                  </div>
                </div>
                {renderCardItem(
                  riderInfo
                )}
              </div>
            </div>
          ) : (
            <div className="flex justify-content-center">
              <p className="text-xl font-medium">No Order Found</p>
            </div>
          )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />

      <SwitchRiderUserModal
        setSwitchRiderUserModalVisible={setSwitchRiderUserModalVisible}
        switchRiderUserModalVisible={switchRiderUserModalVisible}
        sendDataToUserList={receiveDataFromSwitchRiderUserModal}
        brandId={brandId}
        selectedRiderInfo={selectedRiderInfo}
        selectedStoreValue={selectedStoreValue}
      />

    </div>
  );
};

export default SwitchRiderUserList;
